import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Directive({
  selector:
    'wb-link[mbRouterLink], wb-button[mbRouterLink], wb-header-tool-list-item[mbRouterLink], wb-breadcrumb[mbRouterLink]',
})
export class MbRouterLinkDirective implements OnChanges {
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() mbRouterLink = '';
  @Input() mbRouterLinkExtras?: NavigationExtras;
  @Output() mbNavigate = new EventEmitter<void>();

  ngOnChanges(): void {
    const href = this.buildHref();

    if (isPlatformBrowser(this.platformId)) {
      this.elementRef.nativeElement.removeAttribute('href');
    } else {
      this.elementRef.nativeElement.setAttribute('href', href);
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.mbNavigate.emit();
    this.router.navigate([this.mbRouterLink], this.mbRouterLinkExtras);
  }

  private buildHref(): string {
    const fragment = this.mbRouterLinkExtras?.fragment;
    return fragment ? `${this.mbRouterLink}#${fragment.toLowerCase()}` : this.mbRouterLink;
  }
}
